import { app } from './js/main';
import * as styles from './styles/coffeeguide-main.scss';

export default {
  app,
  styles,
};
